import { post, get } from 'api/methods';

import { ApiName } from 'enuns/Api';

export interface ConvocadosElement {
  colaborador: boolean;
  cooperativa: string;
  cpfCnpj: string;
  nomeConvocado: string;
  codigoAgencia: string;
  numeroConta: string;
  oidConvocado: number;
  saldoCotas: number;
}

export interface ConvocadosResponse {
  elements: Array<ConvocadosElement>;
  totalElements: number;
  totalPages: number;
}

export interface ConvocadosRequest {
  colaborador?: boolean;
  coops?: Array<string>;
  cpfOrNome?: string;
  idAssembleia: number;
  page: number;
  size: number;
}

export default {
  list: (data: ConvocadosRequest) => {
    const endpoint = 'convocado/page';
    return post<ConvocadosResponse>(ApiName.Assessor, endpoint, data);
  },
  cooperativas: (idAssembleia: number) => {
    const endpoint = `convocado/assembleia/${idAssembleia}/cooperativas`;
    return get<string[]>(ApiName.Assessor, endpoint);
  },
  relatorio: (data: ConvocadosRequest) => {
    const endpoint = 'relatorio/convocados';
    return post<ArrayBuffer>(ApiName.Assessor, endpoint, data, {
      responseType: 'arraybuffer',
      headers: {
        'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
      },
    });
  },
};
